import { utcOffset } from "./localTime";

/**
 * The time zones the app's times can be shown in — the chart's axis and crosshair, the calendar, the news, the tips:
 * the viewer's device ("local") or one of the trading centres. Each changes its UTC offset only on a full UTC hour
 * (`localTime.ts` caches offsets per UTC hour).
 */
export const TIME_ZONES = [
  "local",
  "UTC",
  "America/New_York",
  "America/Chicago",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Moscow",
  "Asia/Dubai",
  "Asia/Hong_Kong",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
] as const;
export type TimeZoneChoice = (typeof TIME_ZONES)[number];

/** A zone's distance from UTC at time t as the chart's clock shows it ("UTC−4", "UTC+5:30", "UTC"). */
export function offsetLabel(t: number, timeZone: string): string {
  const minutes = Math.round(utcOffset(t, timeZone) / 60_000);
  if (minutes === 0) return "UTC";
  const h = Math.floor(Math.abs(minutes) / 60), m = Math.abs(minutes) % 60;
  return `UTC${minutes > 0 ? "+" : "−"}${h}${m ? `:${String(m).padStart(2, "0")}` : ""}`;
}
